import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TickerMarquee } from "@/components/TickerMarquee";
import { About } from "@/components/About";
import { ChartSection } from "@/components/ChartSection";
import { Tokenomics } from "@/components/Tokenomics";
import { HowToBuy } from "@/components/HowToBuy";
import { Roadmap } from "@/components/Roadmap";
import { Community } from "@/components/Community";
import { Footer } from "@/components/Footer";
import { StickyBuy } from "@/components/StickyBuy";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TickerMarquee />
        <About />
        <ChartSection />
        <Tokenomics />
        <HowToBuy />
        <Roadmap />
        <Community />
      </main>
      <Footer />
      <StickyBuy />
    </>
  );
}
